import { PhoneNumber } from './phone-number.model';

export class PhoneFax extends PhoneNumber {}
